
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import piMessagerecharge from "./components/pi-message-recharge.vue";
import piMessagerechargeBox from "./components/pi-message-recharge-box.vue";
import selectMinMax from "@/components/select-min-max/select-min-max.vue";
import i18n from "@/config/i18n";
import {
  getSmsList,
  getSmsRemainTop5,
  getSmsSysPoolStat
} from "@/api/api-basic-sms";
@Component({
  components: {
    "pi-message-recharge": piMessagerecharge,
    "pi-message-recharge-box": piMessagerechargeBox,
    "pi-select-min-max": selectMinMax
  }
})
export default class MessageManage extends Vue {
  private piMessagerecharge: objAny = {};
  private piMessagerechargeBox: objAny = {};

  public rechange() {
    this.piMessagerecharge.open();
  }
  public rechargeClick(item: objAny) {
    this.piMessagerechargeBox.open(item);
  }
  private minMax: string[] = [];
  private minMax2: string[] = [];
  private total = 0;
  private loading = false;
  private formInline: objAny = {
    usedNumFrom: "",
    usedNumTo: "",
    remainNumFrom: "",
    remainNumTo: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    globalSearch: ""
  };
  private ruleInline = {};
  private smsOprStat: objAny = [];

  private top5List: object[] = [];
  private time: object[] = [];
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("oprName"),
      key: "oprName",
      minWidth: 80
    },
    {
      title: i18n.t("messageManage.totalNum"),
      key: "totalNum",
      minWidth: 120
    },
    {
      title: i18n.t("messageManage.sentNum"),
      key: "sentNum",
      minWidth: 120
    },
    // {
    //   title: "创建时间",
    //   key: "offset",
    //   width: 120
    // },
    {
      title: i18n.t("operation"),
      key: "action",
      minWidth: 120,
      slot: "action"
    }
  ];

  public queryClick(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }
  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getSmsList(this.formInline);

    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
  }
  async getSmsRemainTop5() {
    const ret = await getSmsRemainTop5({});
    if (ret.status === this.$config.apiStatus) {
      this.top5List = ret.data;
    }
  }
  async getSmsSysPoolStat() {
    const ret = await getSmsSysPoolStat({});
    if (ret.status === this.$config.apiStatus) {
      this.smsOprStat = ret.data || [];
    }
  }

  public messageRecord(item: objAny) {
    this.$router.push("/homepage/message/record?operName=" + item.oprName);
  }
  public minMaxChange(val: string[]) {
    this.formInline.remainNumFrom = val[0] || "";
    this.formInline.remainNumTo = val[1] || "";
  }
  public minMax2Change(val: string[]) {
    this.formInline.usedNumFrom = val[0] || "";
    this.formInline.usedNumTo = val[1] || "";
  }
  mounted() {
    this.$nextTick(() => {
      this.piMessagerecharge = this.$refs.piMessagerecharge;
      this.piMessagerechargeBox = this.$refs.piMessagerechargeBox;
    });

    this.getTableList();
    this.getSmsSysPoolStat();
    this.getSmsRemainTop5();
  }
}
